'use client';

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const SIDEBAR_MIN_WIDTH = 340;
const SIDEBAR_MAX_WIDTH = 420;
const SIDEBAR_DEFAULT_WIDTH = 340;

/** Clamp a width value to the allowed sidebar range. */
const clampSidebarWidth = (w: number) =>
  Math.min(SIDEBAR_MAX_WIDTH, Math.max(SIDEBAR_MIN_WIDTH, w));

interface AskEllieSidebarState {
  isOpen: boolean;
  width: number;
  /** TODO: Will be used to inject page-specific context into sidebar chat prompts (e.g. current dashboard data) */
  pageContext: string | null;
  widgetTitle: string | null;
  widgetContext: string | null;
  openSidebar: () => void;
  closeSidebar: () => void;
  toggleSidebar: () => void;
  setWidth: (width: number) => void;
  setPageContext: (context: string | null) => void;
  setWidgetContext: (title: string | null, context: string | null) => void;
  clearWidgetContext: () => void;
}

export const useAskEllieSidebarStore = create<AskEllieSidebarState>()(
  persist(
    (set) => ({
      isOpen: false,
      width: SIDEBAR_DEFAULT_WIDTH,
      pageContext: null,
      widgetTitle: null,
      widgetContext: null,
      openSidebar: () => set({ isOpen: true }),
      closeSidebar: () => set({ isOpen: false }),
      toggleSidebar: () => set((state) => ({ isOpen: !state.isOpen })),
      setWidth: (width: number) =>
        set({
          width: clampSidebarWidth(width),
        }),
      setPageContext: (context: string | null) => set({ pageContext: context }),
      setWidgetContext: (title, context) =>
        set({ widgetTitle: title, widgetContext: context }),
      clearWidgetContext: () => set({ widgetTitle: null, widgetContext: null }),
    }),
    {
      name: 'ask-ellie-sidebar-v2',
      partialize: (state) => ({
        width: state.width,
      }),
    }
  )
);

export {
  clampSidebarWidth,
  SIDEBAR_MIN_WIDTH,
  SIDEBAR_MAX_WIDTH,
  SIDEBAR_DEFAULT_WIDTH,
};
